/**
 * Shared apex-domain helper for first-party, non-httpOnly cookies that must be
 * readable on BOTH the marketing site (apex) and a zone (`app.lokerdollar.com`,
 * etc). The site runs as two separate Cloudflare Workers under one domain, so a
 * host-only cookie set on one is never sent to the other — scoping to
 * `.lokerdollar.com` shares it across both.
 *
 * Lifted verbatim from `src/lib/consent/storage.ts` (was module-private
 * `consentCookieDomain()`) so `ld_attr` (`persistFirstTouchAttribution` in
 * `posthog-provider.tsx`) can use the identical domain logic as the consent
 * cookie — see plan section P0.3(a): before this fix `ld_attr` was written with
 * no `domain`, so first-touch attribution died on the apex→zone hop.
 *
 * Only applied on the real production/preview domain: `Domain=.lokerdollar.com`
 * is invalid (and rejected by the browser) on localhost or an IP-based dev host.
 */

export const APEX_DOMAIN = "lokerdollar.com";
export const APEX_COOKIE_DOMAIN = `.${APEX_DOMAIN}`;

export function apexCookieDomain(): string | undefined {
	const hostname = window.location.hostname;
	if (hostname === APEX_DOMAIN || hostname.endsWith(`.${APEX_DOMAIN}`)) {
		return APEX_COOKIE_DOMAIN;
	}
	return undefined;
}
